import { useQueryParamsSync } from '@atlassian/jira-software-router-utils/src/services/query-params-sync/index.tsx';
import type { TopFilter as State } from '../../common/types';
import { useTableFilterStore } from '../top-filter';
import { QUERY_PARAM_EPIC, QUERY_PARAM_ISSUE_TYPE } from './constants';
import { getQueryParamsFromFilters, getFiltersFromQueryParams } from './utils';

export const useQueryParamSync = () => {
	const [filterState, filterActions] = useTableFilterStore();
	useQueryParamsSync<State>({
		state: filterState,
		onStateChange: filterActions.setFilter,
		onReset: filterActions.resetAllFilters,
		getQueryParamsFromState: getQueryParamsFromFilters,
		getStateFromQueryParams: getFiltersFromQueryParams,
		queryParamsToWatch: [QUERY_PARAM_EPIC, QUERY_PARAM_ISSUE_TYPE],
	});
};
